(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    

    $(document).ready(function ()
    {
    NL.blog.init();
    })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    NL.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
$(document).ready(function ()
{
NL.pdp.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
    $(document).ready(function ()
    {
    NL.pdp.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bak_mzp_20230623_140353"]) return;
  try {
    
    $(document).ready(function ()
    {
    NL.pdp.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zpro-subscription-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    const STORAGE_KEY = 'subcheked';
    const DAY_MS = 86400000;

    const FORM_STYLES = `
      [class*="_formContainer_"] { margin: 0 !important; min-width: 0 !important; }
      [class*="_formFieldset_"] { gap: var(--nl-popup-field-gap) !important; padding: 0 !important; }
      input[class*="_formInputField_"], input[class*="_formPhoneInputField_"], button[class*="_selectToggle_"] {
        box-sizing: border-box;
        height: var(--nl-popup-field-height);
        max-height: none;
      }
      label[class*="_formInputFieldLabel_"] { top: var(--input-label-top) !important; }
      input, label, button, [class*="_textBody_"], [class*="_textHeading_"] { letter-spacing: var(--nl-popup-tracking) !important; }
      [class*="_formSubmitButton_"] { box-sizing: border-box; width: 100%; }
      div[class*="_formDisclaimer_"] {
        margin: var(--nl-popup-consent-gap) 0 0 !important;
        padding: 0 !important;
        font-size: var(--nl-popup-consent-size) !important;
        line-height: var(--nl-popup-consent-line) !important;
        letter-spacing: 0 !important;
        color: var(--nl-popup-consent-color) !important;
      }
      div[class*="_formDisclaimer_"] p { margin: 0 !important; }
      div[class*="_formDisclaimer_"] a { color: inherit !important; text-decoration: underline; }
    `;
    const HIDE_APP_HEADING_STYLES = '[class*="_formHeader_"] { display: none !important; }';

    const readDismissedUntil = () => {
      try {
        return Number(localStorage.getItem(STORAGE_KEY)) || 0;
      } catch {
        return 0;
      }
    };

    const writeDismissedUntil = (timestamp) => {
      try {
        localStorage.setItem(STORAGE_KEY, String(timestamp));
      } catch {
        // Storage unavailable (private mode): the pop-up simply shows again next visit.
      }
    };

    const createStyleSheet = (css) => {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      return sheet;
    };

    // Shopify Forms' CSS variables cover most of the design; these rules cover what it hard-codes (consent size, field
    // gap, button width, and the label offset it measures while the dialog is still hidden). They match class-name
    // prefixes so a Forms release that changes the hashed suffixes still matches, and a rename only drops these
    // refinements.
    const createEmbedStyler = (hideAppHeading) => {
      if (!('adoptedStyleSheets' in Document.prototype)) return null;

      const sheets = [createStyleSheet(FORM_STYLES)];
      if (hideAppHeading) sheets.push(createStyleSheet(HIDE_APP_HEADING_STYLES));

      return (shadowRoot) => {
        if (shadowRoot.adoptedStyleSheets.includes(sheets[0])) return;
        shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, ...sheets];
      };
    };

    customElements.define('newsletter-popup', class NewsletterPopup extends HTMLElement {
      static selectedSectionId = null;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.successButton = this.querySelector('[data-newsletter-popup-success-button]');
        this.isDesignMode = Boolean(window.Shopify?.designMode);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleSectionSelect = this.handleSectionSelect.bind(this);
        this.handleSectionDeselect = this.handleSectionDeselect.bind(this);
        this.handleFormStepChange = this.handleFormStepChange.bind(this);

        this.dialog.addEventListener('close', this.handleDialogClose);
        this.querySelectorAll('[data-newsletter-popup-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });
        this.setUpFormEmbeds();

        if (this.isDesignMode) {
          document.addEventListener('shopify:section:select', this.handleSectionSelect);
          document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
          if (NewsletterPopup.selectedSectionId === this.dataset.sectionId) this.open();
          return;
        }

        if (Date.now() < readDismissedUntil()) return;

        this.preloadImage();
        this.openTimer = setTimeout(() => {
          if (this.hasRenderedForm()) this.open();
        }, Number(this.dataset.delay));
      }

      disconnectedCallback() {
        clearTimeout(this.openTimer);
        this.formObserver?.disconnect();
        this.stepObserver?.disconnect();
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
        document.documentElement.classList.remove('nl-popup-open');
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.dialog.focus();
        document.documentElement.classList.add('nl-popup-open');
      }

      // Shopify Forms renders no form when its service doesn't return one, which would leave a full-screen offer with
      // no way to sign up. The pop-up skips this page instead, and isn't marked dismissed, so it tries again on the next.
      hasRenderedForm() {
        return [...this.querySelectorAll('shopify-forms-embed')].some((embed) =>
          embed.shadowRoot?.querySelector('[data-current-step]:not([data-current-step="error"])')
        );
      }

      handleDialogClose() {
        document.documentElement.classList.remove('nl-popup-open');
        this.rememberDismissal();
      }

      // Not in the theme editor, where opening and closing the pop-up is part of editing it.
      rememberDismissal() {
        if (this.isDesignMode) return;
        writeDismissedUntil(Date.now() + Number(this.dataset.timeoutDays) * DAY_MS);
      }

      handleSectionSelect(event) {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        NewsletterPopup.selectedSectionId = this.dataset.sectionId;
        this.open();
      }

      handleSectionDeselect(event) {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        NewsletterPopup.selectedSectionId = null;
        this.dialog.close();
      }

      // The photo is lazy so it stays out of the initial page load, then fetched once the page has loaded so it is
      // ready when the pop-up opens.
      preloadImage() {
        const image = this.dialog.querySelector('.nl-popup__image');
        if (!image) return;

        const loadImage = () => {
          image.loading = 'eager';
        };

        if (document.readyState === 'complete') {
          loadImage();
        } else {
          window.addEventListener('load', loadImage, { once: true });
        }
      }

      // Shopify Forms renders each form into an open shadow root once its script loads, so embeds are set up as they
      // appear: styled to the design, and watched for the thank-you step.
      setUpFormEmbeds() {
        const styleEmbed = createEmbedStyler(this.hasAttribute('data-hide-app-heading'));
        this.stepObserver = new MutationObserver(this.handleFormStepChange);

        const setUpAll = () => {
          this.querySelectorAll('shopify-forms-embed').forEach((embed) => {
            if (!embed.shadowRoot) return;
            styleEmbed?.(embed.shadowRoot);
            this.stepObserver.observe(embed.shadowRoot, { attributeFilter: ['data-current-step'], subtree: true });
          });
        };

        customElements.whenDefined('shopify-forms-embed').then(setUpAll);
        this.formObserver = new MutationObserver(setUpAll);
        this.formObserver.observe(this, { childList: true, subtree: true });
      }

      // Forms sets data-current-step on its root to the step on screen; "success" is its thank-you message.
      handleFormStepChange(records) {
        if (!records.some(({ target }) => target.dataset.currentStep === 'success')) return;
        this.successButton?.removeAttribute('hidden');
        // Stored now rather than on close, so leaving through the button's link can't bring the pop-up back.
        this.rememberDismissal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
